// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	// CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}


	document.querySelectorAll('.form-module-wrapper').forEach((form) => {
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('form-module-wrapper__container','animate-fade','top');
        let confirmation = form.querySelector('.form-module__confirmation');
        let contentForm = form.querySelector('.form-module');
        form.appendChild(tableWrapper);
        tableWrapper.appendChild(confirmation);
        tableWrapper.appendChild(contentForm);
	});

	if(document.getElementsByClassName('js-accordion-title')){        
        document.querySelectorAll('.accordion').forEach((accordion) => {
            accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
                itemHead.addEventListener('click', (e) => {
                    accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
                        if (itemHead.parentNode !== item) item.classList.remove('open');
                    });
                    itemHead.parentNode.classList.toggle('open');
                });
            });
        });
	}

	if(document.querySelector('.columns__filter')){
		document.querySelector('#select_columns').addEventListener('change',(e)=>{
			let data = e.target.value;
			document.querySelectorAll('.columns__item').forEach((item)=>{
				if(data == 'all'){
					item.classList.remove('hidden');
				}else{
					item.classList.toggle('hidden', item.dataset.filter != data);
				}
			});
			if(document.querySelectorAll('.title-imgs')){
				document.querySelectorAll('.title-imgs').forEach((item)=>{
					item.classList.toggle('hidden', item.dataset.title != data);
				})
			}
			if(document.querySelectorAll('.figure-img')){
				document.querySelectorAll('.figure-img').forEach((item)=>{
					item.classList.toggle('hidden', item.dataset.image != data);
				})
			}
		})
	}

	if(document.querySelector('#gallery-grid')){
		setTimeout(() => {
			document.querySelector('#galleryGrid').classList.add('show');
		}, 500);
	}

	if (document.querySelector('.text-modules-wrapper')) {
        document.querySelectorAll('.text-modules-wrapper .text-modules').forEach((item) => {
            item.classList.add('animate-fade', 'top');
        });
    }

	if (document.querySelector('.global-sitemap')) {
        document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
    }

	if(document.getElementById('menu-mobile')){
		document.querySelector('.navigation.overlay .tertiary-navigation').removeAttribute('id');
		document.querySelector('.navigation.overlay .tertiary-navigation__list').removeAttribute('id');
		document.querySelector('.close-menu').addEventListener('click', ()=>{
			document.getElementById('menu-mobile').classList.remove('show');
		})
		document.querySelector('.js-open-menu').addEventListener('click', ()=>{
			document.getElementById('menu-mobile').classList.add('show');
		})
	}

	var data = document.URL;

	if(data.indexOf("#") != -1){
		let dataFilter = data.split('#')[1];
		let target = document.getElementById(dataFilter);
		let headerHeight = document.querySelector('header').offsetHeight;

		window.scrollTo({
			top: target.offsetTop - headerHeight,
			behavior: 'smooth'
		});
	}


})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}